var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "table-map",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19H2.5C1.83 19 1.2 18.74 0.73 18.27C0.26 17.79 0 17.17 0 16.5V2.5C0 1.83 0.26 1.2 0.73 0.73C1.2 0.26 1.83 0 2.5 0H16.5C17.17 0 17.8 0.26 18.27 0.73C18.74 1.2 19 1.83 19 2.5V16.5C19 17.17 18.74 17.79 18.27 18.27C17.8 18.74 17.17 19 16.5 19ZM10 18H16.5C16.9 18 17.28 17.84 17.56 17.56C17.84 17.28 18 16.9 18 16.5V2.5C18 2.1 17.84 1.72 17.56 1.44C17.28 1.16 16.9 1 16.5 1H10V18ZM2.5 1C2.1 1 1.72 1.16 1.44 1.44C1.16 1.72 1 2.1 1 2.5V16.5C1 16.9 1.16 17.28 1.44 17.56C1.72 17.84 2.1 18 2.5 18H9V1H2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableMap);
export default __webpack_public_path__ + "static/media/table-map.0de9aa5eac6e504c9aee58a1fd40467b.svg";
export { ForwardRef as ReactComponent };